import React from 'react';
import PropTypes from 'prop-types';
import {
	Dimmer,
	Loader
} from 'semantic-ui-react';

const ScreenLoader = ( {
	loading = true,
	message = '',
	...props
} ) => {
	return (
		<Dimmer
			active={ loading }
			page
		>
			<Loader
				active={ loading }
				content={ message }
				{ ...props }
			/>
		</Dimmer>
	);
};

ScreenLoader.propTypes = {
	loading: PropTypes.bool,
	message: PropTypes.string
};

export default ScreenLoader;
